<template>
  <div>
    <div class="ship-info" @click="shipChange">
      <img class="icon-ship" src="../../assets/icons/icon_ship2.png" alt="">
      <span>{{shipName}}</span>
      <img class="icon-arrow-down" src="../../assets/icons/icon_arrow_down.png" alt="">
    </div>
    <div class="product-list" v-if="productList.length">
      <swiper class="product-classify" :options="swiperOption">
        <swiper-slide
          v-for="(item, index) in subCategories"
          :key="`subCategory${index}`"
          :class="['classify-item', {cur: index === classifyActive}]"
          :data-index="index">
          <span :data-index="index">{{item}}</span>
        </swiper-slide>
      </swiper>
      <!-- 产品列表 -->
      <product-list 
      :list="productList.length ? productList[classifyActive].productListItems : []" 
      :category="category"
      />
    </div>
    <no-data :type="noDataType" v-else />

    <!-- 查询船只 -->
    <custom-picker :visible.sync="shipChooseShow" @change="shipCodeLocal = arguments[0]" />
    <!-- wifi介绍 -->
    <wifi-info v-show="type === 'wl'" />
  </div>
</template>

<script>
import { shipList, serviceMenu } from '@/utils/dict'
import ProductList from './ProductList'
import WifiInfo from './BookingWifiInfo'
import CustomPicker from '@/components/CustomPicker'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import NoData from '@/components/NoData'
import { mapState } from 'vuex'

export default {
  name: 'BookingNormalList',

  props: {
    type: String
  },

  components: {
    ProductList,
    WifiInfo,
    CustomPicker,
    NoData
  },

  data () {
    return {
      shipList,
      shipChooseShow: false,
      shipCodeLocal: shipList[0].value,
      swiperOption: {
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 11,
        on: {
          click: swiper => {
            this.classifyActive = Number(swiper.target.attributes['data-index'].nodeValue)
          }
        }
      },
      classifyActive: 0,
      productList: [],
      category: ''
    }
  },

  watch: {
    type: {
      handler () {
        this.shipCodeLocal = this.bookingPage ? this.bookingPage.shipCode : shipList[0].value
        this.getProductList()
      },
      immediate: true
    },
    shipCode () {
      this.getProductList()
    }
  },

  computed: {
    ...mapState(['bookingPage', 'bindTicket']),
    shipName () {
      return shipList.find(x => x.value === this.shipCode).name
    },
    shipCode () {
      return this.bindTicket && this.bindTicket.shipCode ? this.bindTicket.shipCode : this.shipCodeLocal
    },
    subCategories () {
      return this.productList.map(x => x.subCategory)
    },
    noDataType () {
      if (this.type === 'Wifi') return '5'
      if (this.type === 'entertainment') return '6'
      if (this.type === 'dining') return '4'
      if (this.type === 'service') return '3'
      return '1'
    }
  },

  methods: {
    shipChange () {
      if (this.bindTicket) return
      this.shipChooseShow = true
    },
    async getProductList () {
      const categoryName = this.type ? serviceMenu.find(x => x.value === this.type) : serviceMenu.find(x => x.value === this.menuActive)
      if (!categoryName || !categoryName.code) return
      showLoading()
      const { errCode, errMsg, data } = await api.getProductListByCategory(categoryName.code, this.shipCode)
      hideLoading()
      if (errCode === 0) {
        this.classifyActive = this.bookingPage ? this.bookingPage.classifyActive : 0
        this.$store.commit('storeBookingPageData', '')
        this.productList = data.productList.filter(x => x.productListItems && x.productListItems.length)
        this.category = data.category
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ship-info {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 108px;
  font-size: 30px;
  color: @main-color;
  background-color: #fff;
  .icon-ship {
    width: 36px;
    margin-right: 8px;
  }
  .icon-arrow-down {
    width: 21px;
    margin-left: 15px;
  }
}
.product-classify {
  width: 100%;
  padding: 15px 0 45px;
  .classify-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 48px;
    padding: 0 34px;
    border-radius: 24px;
    font-size: 26px;
    color: #1174b8;
    background-color: #fff;
    &.cur {
      .btn-linear-gradient;
      color: #333;
    }
  }
}
.product-list {
  padding: 30px 50px 70px;
}
</style>
